import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    menus: [
      {
        name : 'Ev',
        icon : 'icofont-ui-home',
        to : '/',
        roles : ['KibritAdmin']
      },
      {
        name: 'Statistic',
        icon: 'icofont-chart-bar-graph',
        to: '/Report',
        roles: ['KibritAdmin']
      },
      {
        name: 'Characters',
        icon: 'icofont-businessman',
        to: '/characters',
        roles: ['KibritAdmin']
      },
      {
        name: 'ChoiceValues',
        icon: 'icofont-pie-chart',
        to: '/choiceValues',
        roles: ['KibritAdmin']
      },
      {
        name: 'Scenarios',
        icon: 'icofont-ui-movie',
        to: '/scenarios',
        roles: ['KibritAdmin']
      }, 
      {
        name: 'Scenes',
        icon: 'icofont-paper',
        to: '/scenes',
        roles: ['KibritAdmin']
      }, 
      {
        name: 'Companies',
        icon: 'icofont-ui-home',
        to: '/companies',
        roles: ['KibritAdmin']
      }, 
      {
        name: 'Users',
        icon: 'icofont-ui-user',
        to: '/users',
        roles: ['KibritAdmin']
      }, 
    ],

  },

  getters: {
    getMenus(state){
      return state.menus
    },
  }
});